import { useEffect, useState } from "react";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-md bg-[#fff0ee]/80 border-b"
          : "bg-transparent border-b border-transparent"
      }`}
      style={{
        borderColor: scrolled ? "var(--fp-border)" : "transparent",
      }}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-3 group"
          data-testid="header-logo-link"
        >
          <div className="relative w-10 h-10 rounded-full overflow-hidden flex items-center justify-center"
               style={{ background: "var(--fp-powder)" }}>
            <img
              src="/assets/floppy-poopy-logo.png"
              alt="Logo Floppy Poopy"
              className="w-full h-full object-cover scale-125 translate-y-1"
            />
          </div>
          <div className="flex flex-col leading-none">
            <span
              className="font-display font-bold text-lg tracking-tight"
              style={{ color: "var(--fp-espresso)" }}
            >
              Floppy Poopy
            </span>
            <span
              className="text-[10px] uppercase tracking-[0.18em] mt-0.5"
              style={{ color: "var(--fp-ink-muted)" }}
            >
              Veille sur ton ventre
            </span>
          </div>
        </a>

      </div>
    </header>
  );
}
